const SearchFilter = () => (
    <div>
        Search
    </div>
)

export default SearchFilter